import React, { FC } from 'react';
import ContentLoader from 'react-content-loader';
import { WithStyles, withStyles, Paper } from '@material-ui/core';
import ActivityLoader from './ActivityLoader';

import styles from './PageLoader.styles';

interface Props extends WithStyles<typeof styles> {}

const PageLoader: FC<Props> = ({ classes }) => (
  <div>
    <Paper className={classes.toolbarRoot}>
      <div className={classes.toolbar}>
        <ContentLoader speed={2} width={160} height={30} primaryColor="#f3f3f3" secondaryColor="#ecebeb">
          <rect x="47" y="0" rx="3" ry="3" width="160" height="30" />
        </ContentLoader>
      </div>
    </Paper>
    <div className={classes.content}>
      <ActivityLoader />
      <ActivityLoader />
      <ActivityLoader />
    </div>
    <Paper className={classes.sidebar}>
      <ContentLoader speed={2} width={138} height={30} primaryColor="#f3f3f3" secondaryColor="#ecebeb">
        <rect x="47" y="5" rx="3" ry="3" width="60" height="11" />
        <circle cx="24" cy="12" r="11" />
      </ContentLoader>
      <ContentLoader speed={2} width={138} height={30} primaryColor="#f3f3f3" secondaryColor="#ecebeb">
        <rect x="47" y="5" rx="3" ry="3" width="60" height="11" />
        <circle cx="24" cy="12" r="11" />
      </ContentLoader>
    </Paper>
  </div>
);

export default withStyles(styles)(PageLoader);
